import json from "../json/billingAccountsJfrogaccSubscriptionsJfrogacc.json";

export default async () => JSON.parse(JSON.stringify(await json));
